import { useState } from 'react';
import { Button, Stack, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { RoleDto } from '@sr/dto';
import { useAddUserRole, useDeleteUserRole, useUpdateUserRole, useUserRolesList } from './user-roles.hooks';
import { ErrorBanner } from '../../../shared/ui/error-banner';
import { RoleAccordionEditable } from './roles-accordion-editable';
import { RoleAccordionCreate } from './role-accordion-create';

export const UsersRolesList = () => {
  const { collection: rolesList, isLoading, error } = useUserRolesList();
  const addItem = useAddUserRole();
  const updateItem = useUpdateUserRole();
  const removeItem = useDeleteUserRole();
  const [creating, setCreating] = useState(false);

  const handleDelete = async (dto: RoleDto) => removeItem(dto);

  if (error) return <ErrorBanner errorMessage={error} />;

  return (
    <>
      <Button size="small" variant="contained" sx={{ mb: 2 }} onClick={() => setCreating(true)} startIcon={<AddIcon />} disabled={creating}>
        Добавить
      </Button>

      <Stack spacing={1.25}>
        {creating && (
          <RoleAccordionCreate
            onSave={async (dto) => {
              await addItem(dto);
              setCreating(false);
            }}
            onCancel={() => setCreating(false)}
          />
        )}
        {isLoading && <Typography color="text.secondary">Загрузка…</Typography>}

        {!isLoading && rolesList.length === 0 && <Typography color="text.secondary">Список ролей пуст</Typography>}

        {!isLoading &&
          rolesList.map((role) => (
            <RoleAccordionEditable
              key={role.id}
              role={role}
              onSave={async (input) => {
                await updateItem(input);
              }}
              onDelete={handleDelete}
            />
          ))}
      </Stack>
    </>
  );
};
